import React from 'react'
import { Box, Typography } from '@material-ui/core'
import { useStyles } from './InfoBox.styles'

interface Props {
  boxes: string[]
}
const InfoBox = ({ boxes }: Props) => {
  const classes = useStyles()
  return (
    <Box className={classes.infoBox}>
      {boxes.map((box, index) => (
        <Box
          key={index}
          className={classes.infoBoxColumn}
        >
          <Typography
            component="span"
            className={classes.infoBoxContent}
            dangerouslySetInnerHTML={{
              __html: box
            }}
          />
        </Box>
      ))}
    </Box>
  )
}

export default InfoBox
